import { APIEndpoints } from "@/data/constants/endpoints";
import { Request } from "@/data/api/utils/network";
import {
  RequestParams,
  TCreateRolePayload,
  TUpdateRolePayload,
} from "@/data/types";

/**
 * Get all roles with pagination options
 * @param params Request parameters including organization_id, pageNumber, pageSize, etc.
 */
export const getAllRoles = (params: RequestParams) => {
  return Request({
    path: APIEndpoints.ROLES.BASE,
    type: "GET",
    params,
  });
};

/**
 * Create a new role
 * @param params Request parameters
 * @param payload Create payload
 */
export const createRole = (
  params: RequestParams,
  payload: TCreateRolePayload
) => {
  return Request({
    path: APIEndpoints.ROLES.BASE,
    type: "POST",
    params,
    body: payload,
  });
};

/**
 * Get a role by ID
 * @param roleId The ID of the role to retrieve
 * @param params Request parameters
 */
export const getRoleById = (roleId: string, params: RequestParams) => {
  return Request({
    path: APIEndpoints.ROLES.BY_ID(roleId),
    type: "GET",
    params,
  });
};

/**
 * Update a role by ID
 * @param roleId The ID of the role to update
 * @param params Request parameters
 * @param payload Update payload
 */
export const updateRole = (
  roleId: string,
  params: RequestParams,
  payload: Partial<TUpdateRolePayload>
) => {
  return Request({
    path: APIEndpoints.ROLES.BY_ID(roleId),
    type: "PATCH",
    params,
    body: payload,
  });
};

/**
 * Delete a role by ID
 * @param roleId The ID of the role to delete
 * @param params Request parameters
 */
export const deleteRole = (roleId: string, params: RequestParams) => {
  return Request({
    path: APIEndpoints.ROLES.BY_ID(roleId),
    type: "DELETE",
    params,
  });
};
